import calculateFocalLength from 'helpers/calculations/calculateFocalLength'
import calculateHorizontalFieldOfView from 'helpers/calculations/calculateHorizontalFieldOfView'
import calculateVerticalFieldOfView from 'helpers/calculations/calculateVerticalFieldOfView'
import calculateVerticalAngleOfView from 'helpers/calculations/calculateVerticalAngleOfView'
import calculatePpf from 'helpers/calculations/calculatePpf'
import v from 'helpers/validator/validator'

/**
 * Calculates the horizontal angle of view and dependents focal length, horizontal field of view, vertical angle of view,
 * and vertical field of view. Horizontal angle of view passed in also gets validated.
 * @param {Object} camera - The current camera being updated.
 * @param {String} horizontalAngleOfView - The angle of view to apply and calculate with.
 * @return {Object} The camera passsed in with updated attributes.
*/

export default function updateHorizontalAngleOfView(camera, horizontalAngleOfView) {
  const { horizontalResolution, imagerSize, distanceToTarget, aspectRatio } = camera

  const validatedAngleOfView = v.validateRange({
    value: horizontalAngleOfView,
    base: 0,
    ceiling: 180,
    allowed: [ 360, 270 ]
  }).internal

  const horizontalFieldOfView = calculateHorizontalFieldOfView({ horizontalAngleOfView, distance: distanceToTarget })

  return Object.assign({}, camera, {
    horizontalAngleOfView: validatedAngleOfView,
    focalLength: calculateFocalLength({ horizontalAngleOfView, imagerSize }),
    horizontalFieldOfView,
    ppf: calculatePpf({ horizontalResolution, horizontalFieldOfView }),
    verticalFieldOfView: calculateVerticalFieldOfView({ horizontalFieldOfView, aspectRatio }),
    verticalAngleOfView: calculateVerticalAngleOfView({ horizontalAngleOfView, aspectRatio })
  }, (validatedAngleOfView === 360 || validatedAngleOfView === 270) && { userSelectedGeneralScene: false })
}



// WEBPACK FOOTER //
// ./src/reducers/updateHorizontalAngleOfView.js